import moment from 'moment';
import {store} from '../index'
function toUTC(milisecond) {
    let dateUTC = moment.utc(milisecond);
    return dateUTC;
}
function toLocalTime(milisecond) {
    let state = store.getState()
    let formatDatetime = (state.serviceSetting && state.serviceSetting.serviceSetting) ? state.serviceSetting.serviceSetting.formatDatetime : '24h'
    let localTime
    if(formatDatetime === '24h')
        localTime = moment.utc(milisecond).local().format("DD/MM/YYYY HH:mm");
    else
        localTime = moment.utc(milisecond).local().format("DD/MM/YYYY hh:mm A");
    return localTime;
}
function toLocalDate(milisecond) {
    let localDate = moment.utc(milisecond).local().format("DD/MM/YYYY");
    return localDate;
}

export { toLocalTime , toUTC, toLocalDate }